// RequireAuth.js
import type { JSX } from 'react';
import { Heading, useAuthenticator } from '@aws-amplify/ui-react';
import { Navigate, useLocation } from 'react-router-dom';

export const RequireAuth = ({ children }: { children: JSX.Element }) => {
    const location = useLocation();
    const { authStatus } = useAuthenticator(context => [context.authStatus]);

    if (authStatus === 'configuring') {
        return <Heading level={1}>Loading...</Heading>;
    }

    if (authStatus !== 'authenticated') {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    return children;
};
